import React, {useEffect, useState} from 'react'
import {Button, Drawer, Form, Row} from "antd";
import {enterLoadingState, exitLoadingState} from "../../utils/helpers/commonFunctions";


const Filter = ({showDrawer = true, closer, children, relatedComponent, handler, resetHandler}) => {
    const [form] = Form.useForm()
    const [drawerDisplayState, setDrawerDisplayState] = useState(false)
    const [loadings, setLoadings] = useState([])

    useEffect(() => {
        setDrawerDisplayState(showDrawer)
    }, [showDrawer])

    const handleFormSubmit = () => {
        enterLoadingState(setLoadings)
        handler(form.getFieldsValue())
            .then(() => exitLoadingState(setLoadings))
            .catch(() => exitLoadingState(setLoadings))
    }

    const handleReset = () => {
        form.resetFields()
        resetHandler()
    }

    return (
        <React.Fragment>
            <Drawer
                placement={"right"}
                closable={false}
                onClose={closer}
                open={drawerDisplayState}
                width={'35%'}
                title={`${relatedComponent} Filtreleri`}
            >
                <Form
                    labelAlign={"left"}
                    form={form}
                    labelCol={{span: 8}}
                    wrapperCol={{span: 16}}
                    name={'filterForm'}
                    onFinish={handleFormSubmit}
                >
                    {children}
                </Form>
                <Row justify={'end'}>
                    <Button type={'primary'} onClick={() => form.submit()} loading={loadings[0]}>Filtrele</Button>
                    <Button style={{padding: 0, marginLeft: '16px'}} type={'link'} danger onClick={handleReset}>Temizle</Button>
                </Row>
            </Drawer>
        </React.Fragment>
    )
}
export default Filter